import api from '@/utils/axios';
import { createReferenceOptionsCache } from '@/utils/referenceOptionsCache';

function unwrap(response, fallbackMessage) {
  if (!response.data?.success) {
    const error = new Error(response.data?.error?.message || fallbackMessage);
    error.code = response.data?.error?.code || null;
    throw error;
  }
  return response.data.data;
}

async function postManage(route, action, payload = {}) {
  const response = await api.post(route, { action, ...payload });
  return unwrap(response, 'Request failed');
}

const optionsCache = createReferenceOptionsCache(async (includeInactive) => {
  const response = await api.post('employment-reference/options/get', {
    include_inactive: includeInactive ? 1 : undefined,
  });
  const data = unwrap(response, 'Failed to load employment reference options');
  return {
    employment_types: Array.isArray(data?.employment_types) ? data.employment_types : [],
    companies: Array.isArray(data?.companies) ? data.companies : [],
  };
});

export function invalidateEmploymentReferenceOptions() {
  optionsCache.invalidate();
}

export function fetchEmploymentReferenceOptions(options = {}) {
  return optionsCache.fetch(options);
}

export const employmentReferenceApi = {
  types: {
    create(payload) {
      return postManage('employment-reference/types/manage', 'create', payload);
    },
    update(payload) {
      return postManage('employment-reference/types/manage', 'update', payload);
    },
    delete(payload) {
      return postManage('employment-reference/types/manage', 'delete', payload);
    },
    deactivate(payload) {
      return postManage('employment-reference/types/manage', 'update', {
        ...payload,
        is_active: 0,
      });
    },
  },
  companies: {
    create(payload) {
      return postManage('employment-reference/companies/manage', 'create', payload);
    },
    update(payload) {
      return postManage('employment-reference/companies/manage', 'update', payload);
    },
    delete(payload) {
      return postManage('employment-reference/companies/manage', 'delete', payload);
    },
    deactivate(payload) {
      return postManage('employment-reference/companies/manage', 'update', {
        ...payload,
        is_active: 0,
      });
    },
  },
};
